/**
 * O painel de um paciente: de onde os numeros vem e o que volta.
 *
 * Mora com o COMPONENTE porque e ele quem conhece as tres montagens - o detalhe do
 * colaborador, o do monitoramento e o historico compartilhado. `AnalyticsSource` e
 * justamente o que distingue as duas ORIGENS possiveis, e so ele precisa saber.
 */
/** Os quatro estagios, como o eixo do grafico os escreve. */
export const SLEEP_STAGE_LABELS = {
    0: 'Acordado',
    1: 'REM',
    2: 'Leve',
    3: 'Pesado'
};
/** Os mesmos quatro, como o TOOLTIP os escreve - tres deles ganham "Sono". */
export const SLEEP_STAGE_TOOLTIP = {
    0: 'Acordado',
    1: 'Sono REM',
    2: 'Sono Leve',
    3: 'Sono Pesado'
};
//# sourceMappingURL=patient-analytics.types.js.map